<template>
    <div>
      <base-header class="pb-6">
        <div class="row align-items-center py-4">
          <div class="col-md-6 mb-3 mb-md-0">
            <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb/>
            </nav>
          </div>
          <div class="col-md text-md-right">
            <base-button class="rounded-pill" tag="a" type="celcompink" href="/cuenta/comprar-creditos">
              Comprar Créditos
              <i class="fas fa-plus-circle fa-lg text-pink"></i>
            </base-button>
          </div>
        </div>
      </base-header>

      <div class="container-fluid mt--6">
        <div class="row">
          <div class="col">

            <div class="card">
              <div class="card-header mb-4">
                <div class="d-flex justify-content-md-end">
                  <base-input v-model="keySearch"
                              prepend-icon="fas fa-search"
                              placeholder="Buscar..."
                              class="mb-0">
                  </base-input>
                </div>
              </div>

              <div class="col-12">

                <el-table class="table-responsive table-flush table-striped"
                        header-row-class-name="thead-light"
                        :data="queriedData">

                  <el-table-column label="Fecha"
                                   prop="created"
                                   min-width="200px"
                                   sortable>
                      <template v-slot="{row}">
                                   {{ fechaFormato(row.created) }}
                      </template>
                  </el-table-column>

                  <el-table-column label="ID Transacción"
                                   prop="payTransactionId"
                                   min-width="200px"
                                   sortable>
                      <template v-slot="{row}">
                        {{ row.payTransactionId }}
                      </template>
                  </el-table-column>

                  <el-table-column label="Pasarela de Pago"
                                   prop="paymentPlatformId"
                                   min-width="250px"
                                   sortable>
                      <template v-slot="{row}">
                        {{ row.paymentPlatformId.paymentPlatformName }}
                      </template>
                  </el-table-column>

                  <el-table-column label="Producto"
                                   prop="payProductId"
                                   min-width="250px"
                                   sortable>
                      <template v-slot="{row}">
                        {{ row.payProductId.productName }}
                      </template>
                  </el-table-column>

                  <el-table-column label="Estado"
                                   prop="status"
                                   min-width="150px"
                                   sortable>
                      <template v-slot="{row}">
                          <badge class="mr-4" :type="(row.status==true) ? 'success' : 'danger'">
                              <span class="status">{{ (row.status==true) ? "Pagado" : "Error" }}</span>
                          </badge>
                      </template>
                  </el-table-column>


                </el-table>

              </div>

              <div
                slot="footer"
                class="col-12 mt-4 d-flex justify-content-around justify-content-md-between flex-wrap mb-4 align-items-center"
              >
                  <div class="">
                    <small class="card-category">
                      Mostrando {{ from + 1 }} de {{ to }}  -  {{ total }} entradas

                      <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                      </span>
                    </small>

                  </div>

                  <div class="d-flex align-items-center flex-sm-row flex-column mt-sm-3">

                    <el-select class="select-primary pagination-select mb-3 mb-sm-0 mr-3"
                                v-model="pagination.perPage"
                                placeholder="Per page" >
                      <el-option class="select-primary"
                                  v-for="item in pagination.perPageOptions"
                                  :key="item"
                                  :label="item"
                                  :value="item" >
                      </el-option>
                    </el-select>
                    <base-pagination
                      class="pagination-no-border mb-0"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      :total="total"
                    >
                    </base-pagination>

                  </div>

              </div>
            </div>

          </div>
        </div>


      </div>

  </div>
</template>
<script>
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui'
  import { BasePagination, Modal, Dialog } from '@/components';
  import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload';

  import moment from 'moment';
  import XLSX from 'xlsx';
  import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin';

  import AES256 from 'aes-everywhere';
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Config from '@/config/config.js'
  import { getUser, setUser, encryptAES, horaAhora, search_data, onPermissionsUser } from '@/util/util.js';

  Vue.use(VueAxios, axios)
  Vue.use(Dialog)

  export default {
    mixins: [clientPaginationMixin],
    components: {
      DropzoneFileUpload,
      BasePagination,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      Modal,
      Dialog
    },
    data() {
      return {
        keySearch:"",
        currentPage: 1,
        tableData: [],
        selectedRows: [],
        tabContact: false,
        contactGroup: {},
        contactSingle: {},
        modals: {
          formSingle: false,
          advertenciaSingle: false,
        },
        fileSingle: [],
        permisos: {
          create: onPermissionsUser('credits_transaction.xhtml', 'create'),
          modify: onPermissionsUser('credits_transaction.xhtml', 'modify'),
          destroy: onPermissionsUser('credits_transaction.xhtml', 'destroy'),
        }
      };
    },
    methods: {
     obtenerLista() {

      this.$loading.show()   //delay default is 300ms

      let self = this;
      let user = getUser();

      let js = {
        "email":"",
        "password":"",
        "userPhone":"",
        "plan":"",
        "transaction":"",
        "time_expired":horaAhora(),
        "customer":encodeURIComponent(JSON.stringify(user.customer)),
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.payment_gettransaction, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response)

            if (response.data.response === "200") {
              console.log(response.data.data);

              self.tabContact = false;
              self.tableData = response.data.data;

            } else {
              console.log("No se encontraron registros");
              swal({
                title: 'No se encontraron registros',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'error',
              })
            }

            self.$loading.hide()

        })
        .catch(function (error) {
            console.log("No se encontraron registros",error);
            swal({
              title: 'No se encontraron registros',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-danger',
              type: 'error',
            })
            self.$loading.hide();
        });

      },
      fechaFormato(unixTimestamp) {
        return moment(unixTimestamp).format('YYYY-MM-DD HH:mm:ss');
      },
    },
    watch: {

      'keySearch'(newVal){
          if(newVal.toString().length>3){
            this.searchedData = search_data(newVal, this.tableData);
          }else{
            this.searchedData = this.tableData;
          }
      },

    },
    mounted() {
      this.obtenerLista();
    },
    create() {
      this.$loading.show();
    },
    computed: {

    }
  }
</script>

<style>
.modal-secondary .close > span:not(.sr-only) {
  color: #172b4d;
}
.busy-mask {
  z-index: 1051;
}
</style>
